import { observer } from 'mobx-react-lite'
import React from 'react'
import { Eye, EyeSlash } from 'react-bootstrap-icons'
import { useParams } from 'react-router-dom'
import axiosService from '../../../../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../../../../FormComponents/Toasts'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'
import { statusDisplayName } from '../../../../../../utils/statusDisplayName'

export default observer(function InfluencerColumn({ status }) {
  const { id } = useParams()
  const readOnly = useReadOnly()

  const toggleIsVisible = () => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/campaign_authentication_statuses/${status?.id}`, { campaign_authentication_status: { is_visible: !status.is_visible }})
    .then(updatedStatus => {
      status.is_visible = updatedStatus.is_visible
      toastSuccess(status.is_visible ? 'Column visible for advertiser' : 'Column is hidden from advertiser')
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <button className={`bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-xl p-2 font-semibold flex items-center dark:text-white ${readOnly ? 'cursor-default' : ''}`} onClick={toggleIsVisible} disabled={readOnly}>
      <p className="mr-2">{statusDisplayName(status)}</p>
      {status.is_visible ? <Eye className="dark:text-white" /> : <EyeSlash className="dark:text-white" />}
    </button>
  )
})